import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('updateCalendarEventSelections', (selectedIds: string[]) => {
    let optionStore = getStore();
    optionStore.selectedCalendarIds = selectedIds;
});
